/**
 * Theoric — Abandoned Cart Recovery
 *
 * Supported links:
 *   /?recover_cart=1&coupon=VOLTEI10&utm_medium=email
 *     Main flow: use the visitor's current Shopify cart, apply coupon, go to native checkout.
 *
 *   /?recover_cart=1&items=123456789:1,987654321:2
 *     Optional flow: restore explicit variant IDs before checkout.
 */
(function () {
  'use strict';

  var COOKIE_DAYS = 30;
  var UTM_COOKIE = 'utmsTrack';
  var STORAGE_KEY = 'theoric_abandoned_cart_recovery';
  var EMPTY_PARAM = 'cart_recovery_empty';
  var N8N_ENDPOINT = 'https://theoric-n8n-webhook.ns2f8o.easypanel.host/webhook/events';
  var EMPTY_CART_ATTEMPTS = 14;
  var EMPTY_CART_RETRY_DELAY = 450;
  var RECOVERY_FLAGS = ['recover_cart', 'cart_recovery', 'abandoned_cart', 'carrinho_abandonado', 'ac'];
  var ITEM_PARAMS = ['items', 'cart_items', 'variants'];
  var COUPON_PARAMS = ['coupon', 'cupom', 'discount', 'promocode', 'promo_code', 'recovery_coupon'];

  function hasUrlSupport() {
    return typeof URL !== 'undefined' && typeof URLSearchParams !== 'undefined';
  }

  function setRawCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax; Secure';
  }

  function setAbandonedCartUtms(meta) {
    var params = new URLSearchParams();
    params.set('utm_source', 'abandoned_cart');
    params.set('utm_medium', meta.medium || 'link');
    params.set('utm_campaign', 'cart_recovery');
    if (meta.content) params.set('utm_content', meta.content);
    if (meta.term) params.set('utm_term', meta.term);
    setRawCookie(UTM_COOKIE, params.toString(), COOKIE_DAYS);
  }

  function getCurrentUrl() {
    if (!hasUrlSupport()) return null;
    try { return new URL(window.location.href); } catch (e) { return null; }
  }

  function isTruthyParam(value) {
    if (value === null || value === undefined) return false;
    if (value === '') return true;
    return !/^(0|false|no|nao)$/i.test(String(value));
  }

  function getRecoveryFlag(params) {
    for (var i = 0; i < RECOVERY_FLAGS.length; i++) {
      if (params.has(RECOVERY_FLAGS[i]) && isTruthyParam(params.get(RECOVERY_FLAGS[i]))) {
        return RECOVERY_FLAGS[i];
      }
    }
    return '';
  }

  function getCouponFromParams(params) {
    for (var i = 0; i < COUPON_PARAMS.length; i++) {
      var coupon = params.get(COUPON_PARAMS[i]);
      if (coupon) return coupon.trim();
    }
    return '';
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function buildMeta(url, flag) {
    var params = url.searchParams;
    var medium = params.get('utm_medium') || params.get('channel') || params.get('medium') || 'link';
    var content = params.get('utm_content') || params.get('recovery_id') || params.get('token') || params.get('checkout_id') || '';
    var coupon = getCouponFromParams(params);

    return {
      flag: flag,
      medium: medium,
      content: content,
      coupon_code: coupon,
      term: params.get('utm_term') || '',
      token: params.get('token') || '',
      recovery_id: params.get('recovery_id') || params.get('checkout_id') || '',
      landing_page: window.location.pathname,
      clicked_at: new Date().toISOString()
    };
  }

  function saveMeta(meta) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(meta));
    } catch (e) {}
  }

  function pushEvent(eventName, data) {
    try {
      if (
        window.theoric &&
        window.theoric.internal &&
        typeof window.theoric.internal.canTrack === 'function' &&
        !window.theoric.internal.canTrack()
      ) return;

      if (typeof window.theoricLoadInfluencerGtag === 'function') {
        window.theoricLoadInfluencerGtag();
      }

      if (typeof gtag === 'function') {
        gtag('event', eventName, data || {});
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, data || {}));
    } catch (e) {}
  }

  function sendN8NEvent(eventType, meta) {
    try {
      if (
        window.theoric &&
        window.theoric.internal &&
        typeof window.theoric.internal.canTrack === 'function' &&
        !window.theoric.internal.canTrack()
      ) return;
    } catch (e) {}

    var customerId = document.body && document.body.dataset ? document.body.dataset.customerId || '' : '';
    var sessionId = '';
    try {
      sessionId = window.ShopifyAnalytics && window.ShopifyAnalytics.lib
        ? window.ShopifyAnalytics.lib.user().traits().uniqToken || ''
        : '';
    } catch (e) {}

    var payload = {
      event_type: eventType,
      customer_id: customerId,
      session_id: sessionId,
      location_path: window.location.pathname,
      metadata: meta || {},
      timestamp: new Date().toISOString()
    };

    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(N8N_ENDPOINT, JSON.stringify(payload));
        return;
      }
    } catch (e) {}

    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', N8N_ENDPOINT, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(payload));
    } catch (e) {}
  }

  function requestJson(method, url, body, success, error) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (body) xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          success(JSON.parse(xhr.responseText));
        } catch (e) {
          if (typeof error === 'function') error(e);
        }
      } else if (typeof error === 'function') {
        error(xhr);
      }
    };
    xhr.send(body ? JSON.stringify(body) : null);
  }

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getAjaxCartUrl(endpoint) {
    var root = getRoutesRoot();
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now();
  }

  function getCart() {
    return new Promise(function (resolve, reject) {
      var cartJsUrl = getAjaxCartUrl('cart.js');
      var cartJsonUrl = getAjaxCartUrl('cart.json');

      if (window.fetch) {
        fetch(cartJsUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart request failed.');
          return response.json();
        }).then(resolve).catch(function () {
          requestJson('GET', cartJsonUrl, null, resolve, function () {
            requestJson('GET', cartJsUrl, null, resolve, reject);
          });
        });
        return;
      }

      requestJson('GET', cartJsUrl, null, resolve, function () {
        requestJson('GET', cartJsonUrl, null, resolve, reject);
      });
    });
  }

  function getCartItemCount(cart) {
    if (!cart) return 0;
    if (typeof cart.item_count === 'number') return cart.item_count;
    if (!Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      var quantity = parseInt(item && item.quantity, 10);
      return total + (quantity > 0 ? quantity : 0);
    }, 0);
  }

  function getCartWithRetries(attempts, delay) {
    attempts = attempts || 3;
    delay = delay || 350;

    return getCart().then(function (cart) {
      var itemCount = getCartItemCount(cart);
      if (itemCount > 0 || attempts <= 1) return cart;

      return new Promise(function (resolve) {
        setTimeout(resolve, delay);
      }).then(function () {
        return getCartWithRetries(attempts - 1, Math.min(delay + 250, 1000));
      });
    });
  }

  function clearCart() {
    return new Promise(function (resolve, reject) {
      requestJson('POST', '/cart/clear.js', null, resolve, reject);
    });
  }

  function addItems(items) {
    return new Promise(function (resolve, reject) {
      if (!items.length) {
        resolve(null);
        return;
      }

      requestJson('POST', '/cart/add.js', { items: items }, resolve, function () {
        addItemsOneByOne(items).then(resolve).catch(reject);
      });
    });
  }

  function addItemsOneByOne(items) {
    var added = 0;
    return items.reduce(function (promise, item) {
      return promise.then(function () {
        return new Promise(function (resolve) {
          requestJson('POST', '/cart/add.js', { items: [item] }, function () {
            added += 1;
            resolve();
          }, resolve);
        });
      });
    }, Promise.resolve()).then(function () {
      if (!added) throw new Error('No recovery items could be added.');
      return getCart();
    });
  }

  function getRawItems(params) {
    for (var i = 0; i < ITEM_PARAMS.length; i++) {
      var raw = params.get(ITEM_PARAMS[i]);
      if (raw) return raw;
    }
    return '';
  }

  function getRawItemsFromBase64(params) {
    var raw = params.get('items_b64') || params.get('cart_b64') || '';
    if (!raw || typeof atob !== 'function') return '';
    try { return atob(raw); } catch (e) { return ''; }
  }

  function normalizeItem(item) {
    if (!item) return null;
    var id = parseInt(item.id || item.variant_id || item.variantId, 10);
    var quantity = parseInt(item.quantity || item.qty || 1, 10);
    if (!id || quantity <= 0) return null;
    return {
      id: id,
      quantity: quantity,
      properties: Object.assign({}, item.properties || {}, { _cart_recovery: 'true' })
    };
  }

  function parseItemsFromJson(raw) {
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.map(normalizeItem).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function parseItemsFromList(raw) {
    return raw.split(/[;,|]/).map(function (part) {
      var match = part.trim().match(/^(\d+)\s*[:xX]\s*(\d+)$/);
      if (!match) match = part.trim().match(/^(\d+)$/);
      if (!match) return null;
      return normalizeItem({ id: match[1], quantity: match[2] || 1 });
    }).filter(Boolean);
  }

  function parseRecoveryItems(params) {
    var raw = getRawItems(params) || getRawItemsFromBase64(params);
    if (!raw) return [];

    var decoded = raw;
    try { decoded = decodeURIComponent(raw); } catch (e) {}

    if (/^\s*\[/.test(decoded)) {
      return parseItemsFromJson(decoded);
    }

    return parseItemsFromList(decoded);
  }

  function buildDeltaItems(cart, desiredItems) {
    var currentQtyByVariant = {};
    (cart.items || []).forEach(function (item) {
      var variantId = String(item.variant_id || item.id);
      currentQtyByVariant[variantId] = (currentQtyByVariant[variantId] || 0) + item.quantity;
    });

    return desiredItems.map(function (item) {
      var currentQty = currentQtyByVariant[String(item.id)] || 0;
      var delta = item.quantity - currentQty;
      if (delta <= 0) return null;
      return Object.assign({}, item, { quantity: delta });
    }).filter(Boolean);
  }

  function showEmptyToast() {
    if (document.getElementById('theoric-cart-recovery-toast')) return;

    var bottomOffset = document.getElementById('theoric-cart-recovery-coupon-toast') ? '76px' : '18px';
    var toast = document.createElement('div');
    toast.id = 'theoric-cart-recovery-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('style',
      'position:fixed;left:50%;bottom:' + bottomOffset + ';z-index:9998;' +
      'transform:translate(-50%, 24px);opacity:0;' +
      'max-width:min(92vw, 440px);background:#5a4a42;color:#fff;' +
      'padding:12px 16px;border-radius:4px;box-shadow:0 12px 28px rgba(0,0,0,.18);' +
      'font-family:Avantt,sans-serif;font-size:14px;line-height:1.35;' +
      'display:flex;align-items:center;gap:12px;transition:transform .35s ease, opacity .35s ease;'
    );
    toast.innerHTML =
      '<span>Seu carrinho anterior estava vazio. Trouxemos voce para todos os produtos.</span>' +
      '<button type="button" aria-label="Fechar aviso" style="' +
      'background:none;border:0;color:#fff;font-size:20px;line-height:1;cursor:pointer;padding:0 2px;">&times;</button>';

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.transform = 'translate(-50%, 0)';
      toast.style.opacity = '1';
    });

    function dismiss() {
      toast.style.transform = 'translate(-50%, 24px)';
      toast.style.opacity = '0';
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
    }

    toast.querySelector('button').addEventListener('click', dismiss);
    setTimeout(dismiss, 7000);
  }

  function showCouponToast(coupon) {
    if (!coupon || document.getElementById('theoric-cart-recovery-coupon-toast')) return;

    var bottomOffset = document.getElementById('theoric-cart-recovery-toast') ? '76px' : '18px';
    var toast = document.createElement('div');
    toast.id = 'theoric-cart-recovery-coupon-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('style',
      'position:fixed;left:50%;bottom:' + bottomOffset + ';z-index:9998;' +
      'transform:translate(-50%, 24px);opacity:0;' +
      'max-width:min(92vw, 440px);background:#5a4a42;color:#fff;' +
      'padding:12px 16px;border-radius:4px;box-shadow:0 12px 28px rgba(0,0,0,.18);' +
      'font-family:Avantt,sans-serif;font-size:14px;line-height:1.35;' +
      'display:flex;align-items:center;gap:10px;transition:transform .35s ease, opacity .35s ease;'
    );
    toast.innerHTML =
      '<span>Cupom <strong>' + escapeHtml(coupon) + '</strong> ativado automaticamente</span>' +
      '<button type="button" aria-label="Fechar aviso" style="' +
      'background:none;border:0;color:#fff;font-size:20px;line-height:1;cursor:pointer;padding:0 2px;">&times;</button>';

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.transform = 'translate(-50%, 0)';
      toast.style.opacity = '1';
    });

    function dismiss() {
      toast.style.transform = 'translate(-50%, 24px)';
      toast.style.opacity = '0';
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
    }

    toast.querySelector('button').addEventListener('click', dismiss);
    setTimeout(dismiss, 7000);
  }

  function cleanTechnicalParams(url) {
    var paramsToDelete = RECOVERY_FLAGS.concat([
      EMPTY_PARAM,
      'items',
      'cart_items',
      'variants',
      'items_b64',
      'cart_b64',
      'replace_cart',
      'channel',
      'medium',
      'token',
      'checkout_id',
      'recovery_id'
    ]).concat(COUPON_PARAMS);

    paramsToDelete.forEach(function (param) {
      url.searchParams.delete(param);
    });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', url.pathname + (url.search ? url.search : '') + url.hash);
    }
  }

  function removeRecoveryOnlyParams(url) {
    var paramsToDelete = [
      EMPTY_PARAM,
      'channel',
      'medium',
      'token',
      'checkout_id',
      'recovery_id'
    ].concat(COUPON_PARAMS);

    paramsToDelete.forEach(function (param) {
      url.searchParams.delete(param);
    });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', url.pathname + (url.search ? url.search : '') + url.hash);
    }
  }

  function buildEmptyRedirect(meta) {
    var url = new URL('/collections/todos', window.location.origin);
    url.searchParams.set(EMPTY_PARAM, '1');
    url.searchParams.set('utm_source', 'abandoned_cart');
    url.searchParams.set('utm_medium', meta.medium || 'link');
    url.searchParams.set('utm_campaign', 'cart_recovery');
    if (meta.content) url.searchParams.set('utm_content', meta.content);
    if (meta.coupon_code) url.searchParams.set('coupon', meta.coupon_code);
    return url.href;
  }

  function buildNativeCheckoutUrl(meta) {
    if (!meta.coupon_code) return '/checkout';

    return '/discount/' + encodeURIComponent(meta.coupon_code) +
      '?redirect=' + encodeURIComponent('/checkout');
  }

  function redirectToProducts(meta, reason) {
    pushEvent('abandoned_cart_recovery_empty', {
      reason: reason || 'empty_cart',
      utm_medium: meta.medium || 'link',
      coupon_code: meta.coupon_code || '',
      recovery_id: meta.recovery_id || '',
      token: meta.token || ''
    });
    sendN8NEvent('abandoned_cart_recovery_empty', Object.assign({}, meta, { reason: reason || 'empty_cart' }));
    window.location.href = buildEmptyRedirect(meta);
  }

  function goToCheckout(meta) {
    pushEvent('abandoned_cart_recovery_checkout', {
      utm_medium: meta.medium || 'link',
      coupon_code: meta.coupon_code || '',
      recovery_id: meta.recovery_id || '',
      token: meta.token || ''
    });
    sendN8NEvent('abandoned_cart_recovery_checkout', meta);

    window.location.href = buildNativeCheckoutUrl(meta);
  }

  function handleRecovery(url, flag) {
    var params = url.searchParams;
    var meta = buildMeta(url, flag);
    var desiredItems = parseRecoveryItems(params);
    var shouldReplaceCart = isTruthyParam(params.get('replace_cart'));

    setAbandonedCartUtms(meta);
    saveMeta(meta);
    if (meta.coupon_code && document.body) showCouponToast(meta.coupon_code);
    pushEvent('abandoned_cart_recovery_click', {
      utm_medium: meta.medium || 'link',
      coupon_code: meta.coupon_code || '',
      recovery_id: meta.recovery_id || '',
      token: meta.token || '',
      has_items_payload: desiredItems.length > 0
    });
    sendN8NEvent('abandoned_cart_recovery_click', Object.assign({}, meta, {
      has_items_payload: desiredItems.length > 0,
      replace_cart: shouldReplaceCart
    }));

    var cartPromise = shouldReplaceCart && desiredItems.length
      ? clearCart().then(getCart)
      : getCartWithRetries(desiredItems.length ? 1 : EMPTY_CART_ATTEMPTS, EMPTY_CART_RETRY_DELAY);

    cartPromise.then(function (cart) {
      if (desiredItems.length) {
        return addItems(buildDeltaItems(cart, desiredItems)).then(getCart);
      }
      return cart;
    }).then(function (cart) {
      var itemCount = getCartItemCount(cart);
      if (itemCount > 0) {
        pushEvent('abandoned_cart_recovery_restored', {
          item_count: itemCount,
          utm_medium: meta.medium || 'link',
          coupon_code: meta.coupon_code || '',
          recovery_id: meta.recovery_id || '',
          token: meta.token || ''
        });
        cleanTechnicalParams(url);
        goToCheckout(meta);
        return;
      }

      redirectToProducts(meta, desiredItems.length ? 'items_unavailable_or_empty' : 'empty_cart');
    }).catch(function () {
      redirectToProducts(meta, 'recovery_error');
    });
  }

  function handleEmptyNotice(url) {
    var params = url.searchParams;
    if (!params.has(EMPTY_PARAM)) return false;

    var meta = buildMeta(url, EMPTY_PARAM);
    setAbandonedCartUtms(meta);

    function showNotice() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          if (meta.coupon_code) showCouponToast(meta.coupon_code);
          showEmptyToast();
        });
      } else {
        if (meta.coupon_code) showCouponToast(meta.coupon_code);
        showEmptyToast();
      }

      removeRecoveryOnlyParams(url);
    }

    getCartWithRetries(8, 350).then(function (cart) {
      if (getCartItemCount(cart) > 0) {
        removeRecoveryOnlyParams(url);
        goToCheckout(meta);
        return;
      }

      showNotice();
    }).catch(showNotice);

    return true;
  }

  function init() {
    var url = getCurrentUrl();
    if (!url) return;

    if (handleEmptyNotice(url)) return;

    var flag = getRecoveryFlag(url.searchParams);
    if (!flag) return;

    handleRecovery(url, flag);
  }

  init();
})();
